module.exports = __webpack_public_path__ + "media/images/clia-e8b69f53606c600896d6b4f466a911fc.jpg";